import React from 'react'
import { func } from 'prop-types'
import { css } from '@emotion/core'
import { useAamState } from '../../../state/AamStore'
import PersonViewer from '../../../../../shared/components/PersonViewer/PersonViewer'
import { PersonViewerProvider } from '../../../../../shared/components/PersonViewer/state/PersonViewerStore'
import { PersonType } from '../../../../../shared/propTypes/personDataProps'

const ancestorModalStyle = css`
  width: 100vw;
  height: 100vh;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
`
const clearUrl = () => {
  const params = new URLSearchParams(window.location.search)
  params.delete('experience')
  window.history.replaceState({}, '', decodeURIComponent(`${window.location.pathname}?${params}`))
}

export default function AncestorDetails({ person, setOpenAncestorDetails }) {
  const state = useAamState()

  return (
    <div css={ancestorModalStyle}>
      <PersonViewerProvider>
        <PersonViewer
          personData={person}
          clearPerson={() => {
            setOpenAncestorDetails(false)
            clearUrl()
          }}
          tree={state.tree}
        />
      </PersonViewerProvider>
    </div>
  )
}

AncestorDetails.propTypes = {
  person: PersonType,
  setOpenAncestorDetails: func,
}
